/**
 * Created by Mohamed on 2/21/2016.
 */
window.PaymentStripe = new function () {
    var self = this;

    var isInitialized;

    self.init = function () {

        var defer = $q.defer();

        if (!isInitialized) {
            $.ajax({
                url: 'https://js.stripe.com/v2/',
                dataType: 'script',
                success: function () {
                    var publishableKey = publicConfiguration.getStripePublishableKey();
                    Stripe.setPublishableKey(publishableKey);
                    isInitialized = true;
                    defer.resolve();
                }
            });
        }
        else {
            defer.resolve();
        }

        return defer.promise;
    };

    self.tokenBeingCreated = false;

    self.createToken = function (stripeData, callback) {
        if (!self.tokenBeingCreated) {
            self.tokenBeingCreated = true;

            Stripe.card.createToken(stripeData, function (status, cardDetails) {
                self.tokenBeingCreated = false;
                callback && callback(status, cardDetails);
            });
        }
    };
};
